import { render } from "./daythree-grid.vue?vue&type=template&id=3f1d27cc"
import script from "./daythree-grid.vue?vue&type=script&lang=js"
export * from "./daythree-grid.vue?vue&type=script&lang=js"
script.render = render

export default script